// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"423":"51c937c0","447":"ceed7bac","754":"dd707c0d","861":"d52ec2d9","871":"91ee38b6"}[chunkId] + ".css";
};